var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2KitchenBis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.94 39H66v6a10 10 0 01-10 10H36a10.1 10.1 0 01-10-10v-2H8.94a2 2 0 110-4zm49.39-12H48v-5h-4v5H33.7a7.78 7.78 0 00-7.7 8h40a7.78 7.78 0 00-7.67-8z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Kitchen_bis.dd9be592.svg";
export { SvgE2KitchenBis as ReactComponent };